import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useSignal, useContext, useTask$ } from "@builder.io/qwik";
import { isServer } from "@builder.io/qwik/build";
import { comboboxContextId } from "./combobox-context.qwik.mjs";
const ComboboxHiddenSelectOption = component$(({ value, displayValue, nativeSelectRef, index, ...rest }) => {
  const optionRef = useSignal();
  const context = useContext(comboboxContextId);
  useTask$(async function modularFormsValidation({ track }) {
    track(() => context.selectedValuesSig.value);
    if (isServer || !nativeSelectRef.value || !optionRef.value)
      return;
    const inputEvent = new Event("input", {
      bubbles: false
    });
    nativeSelectRef.value?.dispatchEvent(inputEvent);
    const value2 = context.itemsMapSig.value.get(index)?.value;
    if (!value2) {
      throw new Error("Qwik UI: value not found when trying to select or unselect an item.");
    }
    const selectedValues = context.selectedValuesSig.value;
    optionRef.value.selected = Array.isArray(selectedValues) ? selectedValues.includes(value2) : selectedValues === value2;
  });
  return /* @__PURE__ */ jsx("option", {
    ref: optionRef,
    value,
    ...rest,
    children: displayValue
  });
});
export {
  ComboboxHiddenSelectOption
};
